import { AxiosError, isAxiosError } from 'axios';

/** Stable error key of a backend response (`code`; older responses only had it in `error`). */
export const backendErrorCode = (data: BackendErrorData | null | undefined): string | undefined =>
  data?.code ?? data?.error;

/** Shape of error response data from the backend API */
export interface BackendErrorData {
  code?: string;
  field?: string;
  loginMode?: boolean;
  details?: Array<{ code: string; field?: string; max?: number }>;
  error?: string;
  message?: string;
}

export type ApiError = AxiosError<BackendErrorData>;

/**
 * Extract a human-readable message from an unknown error.
 * Safe to use in `catch (error: unknown)` blocks.
 */
export function getErrorMessage(error: unknown, fallback = 'An unknown error occurred'): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return fallback;
}

/**
 * Extract a user-facing error message from an API error,
 * checking the response body first, then falling back to the error message.
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (isAxiosError<BackendErrorData>(error)) {
    return error.response?.data?.error || error.response?.data?.message || error.message || fallback;
  }
  return getErrorMessage(error, fallback);
}

// Re-export for convenience
export { isAxiosError };
